export enum Navigation {
  INTERACTION ='Interaction',
  QUEUE = 'Queue',
  ASSIGNMENT = 'Assignment',
  CALENDER = 'Calender',
  DIRECTORY = 'Directory',
  WEM = 'WEM',
  AGENT_MESSAGES = 'AgentMessages',
  APP_HEALTH = 'AppHealth',
  SETTINGS = 'Settings',
  CONVERSATIONS = 'Conversations',
  DASHBOARD = 'Dashboard',
  CUSTOMERCARD = 'CustomerCard',
  INTERACTIONSEARCH = 'InteractionSearch',
  QUICK_REPLY = 'QuickReply',
  REPORTS = 'Reports',
  ENLIGHTEN = 'Enlighten',
  SENTIMENT = 'Sentiment',
  CONTACTHISTORY = 'ContactHistory',
  CUSTOMWORKSPACE = 'CustomWorkspace',
}
